<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Tussentijdse toets</h1>
      <p>
        Als je rijlessen aan het volgen bent en je graag zo goed mogelijk wilt
        voorbereiden op het
        <nuxt-link to="/informatie-over-rijscholen/praktijkexamen">
          praktijkexamen </nuxt-link
        >, kun je je rijschool een tussentijdse toets laten inplannen. Wat houdt
        een tussentijdse toets precies in? En waarom zou je er gebruik van
        maken? Op Rijscholenvergelijker.nl kom je erachter, lees je meer tips
        over het halen van je rijbewijs én vraag je gratis informatie aan bij
        rijscholen in je eigen omgeving!
      </p>

      <h2>Praktijk examen voorbereiden</h2>
      <p>
        De tussentijdse toets is een toets die min of meer dient als generale
        repetitie voor je praktijkexamen. Zo kun je vast wennen aan de
        omstandigheden en wordt de spanning voor het examen grotendeels
        weggehaald. Leerlingen die eerst deelnemen aan de tussentijdse toets en
        pas daarna op gaan voor hun examen, hebben een grotere slagingskans dan
        de overige kandidaten. Je rij-instructeur rijdt gewoon met je mee, dus
        na afloop kunnen jullie samen bespreken waaraan er nog moet worden
        gewerkt. Bovendien kun je met een tussentijdse toets alvast de
        bijzondere manoeuvres afsluiten, zodat je hier in ieder geval niet meer
        op hoeft te letten tijdens je examen. Meestal wordt de toets afgenomen
        na ongeveer driekwart van je rijlessen.
      </p>

      <h2>Gratis informatie</h2>
      <p>
        Aan een tussentijdse toets zijn weliswaar kosten verbonden; je vergroot
        er wel de kans mee dat je meteen slaagt voor je examen. Je kunt er dus
        uiteindelijk tijd mee winnen en euro’s mee besparen. Zo is het ook met
        rijscholen: bij de school met het laagste tarief ben je uiteindelijk
        lang niet altijd het minste kwijt. Vraag vandaag nog informatie aan van
        verschillende <nuxt-link to="/"> rijscholen </nuxt-link> in je eigen
        omgeving, kies voor de beste optie en houd uiteindelijk tot honderden
        euro’s over door snel je rijbewijs in de wacht te slepen!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Tussentijdse toets: wat is het en wat zijn de voordelen?',
      headDescription:
        'Wat is precies de tussentijdse toets en waarom zou je er gebruik van maken? Op Rijscholenvergelijker.nl lees je het én vraag je gratis informatie aan!',
    }
  },
}
</script>
